import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SecretariaService {

  sociosUlr: string;

  constructor(
    private http: HttpClient
  ) {
    this.sociosUlr = `${environment.apiUrl}/socios`;
  }

  buscarFotoSocio(id: number, token: any){
    const httpOpcoes = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.get(`${this.sociosUlr}/${id}/foto`, httpOpcoes);
  }
  
  buscarDadosSocioPorId(idSocio: number, token: any){
    const httpHeaders = {
      headers:  new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })}
    return this.http.get(`${this.sociosUlr}/${idSocio}/foto`, httpHeaders);
  }
}